// import { createSelector } from 'reselect';

export const getAvatarBlobUrl = (state, ownProps) => {
  return state.avatar.blobUrlsByDeviceId[ownProps.deviceId] || null;
};
